import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UsuarioContext } from '../../providers/personaContext';

/**
 * Permisos del módulo Formación, leídos del UsuarioContext (mismo origen
 * que usa el resto del proyecto: GET /api/permisos/mios). El Super
 * Administrador pasa siempre.
 */
export function useFormAuth() {
  const ctx = useContext(UsuarioContext) || {};
  const superAdmin = (ctx.persona?.rol || '').toLowerCase() === 'super administrador';
  const permisos = Array.isArray(ctx.permisos) ? ctx.permisos : [];
  const can = (clave) => superAdmin || permisos.includes(clave);
  // anti-blip: si aún no cargaron los permisos, esperamos
  const permisosCargados = superAdmin || ctx.permisosCargados !== false;
  return { superAdmin, permisos, can, permisosCargados, cargando: ctx.cargando };
}

/**
 * Guard por sección, equivalente a InvGuard del módulo Inventario.
 * Uso en routes.jsx:
 *   <FormGuard anyOf={['formacion.lae.categorias.view']}><LaeCategorias/></FormGuard>
 *   <FormGuard superOnly>…</FormGuard>
 */
export function FormGuard({ anyOf = [], superOnly = false, children }) {
  const { superAdmin, can, permisosCargados } = useFormAuth();

  if (!permisosCargados) return null; // evita parpadeo mientras cargan permisos

  const ok = superOnly ? superAdmin : (superAdmin || anyOf.some((c) => can(c)));
  if (ok) return children;

  // Logado pero sin permiso para esta sección
  return <div className="px-6 py-5 text-slate-500">No tienes permiso para ver esta sección.</div>;
}
